import React from 'react';
import ComingSoon from 'views/ComingSoon';
import { SEO } from 'components/seo';

const IndexPage = (): JSX.Element => {
  return <ComingSoon />;
};

export default IndexPage;

export const Head = () => (
  <SEO
    title="A Better CoreEstate.io Is on the Way"
    description="We’re rebuilding CoreEstate.io to bring you a more powerful, modern, and impactful experience."
  />
);
